module.exports = __webpack_public_path__ + "static/assets/afd83272a776970c9271c9f8da1c27fa.svg";